// import React, { useCallback, useEffect, useRef, useState } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import './SearchResultsPage.css';
// import ClipLoader from 'react-spinners/ClipLoader';
// import { COURSES_URL, ENROLLMENT_URL, SaveSearchedCourses } from '../../Services/courseService';
// import FilterComponent from './FilterComponent';
// import { useTranslation } from 'react-i18next'; 
// import 'react-toastify/dist/ReactToastify.css';

// const SearchResultsPage = () => {
//     const location = useLocation();
//     const query = new URLSearchParams(location.search).get('query');
//     const [courses, setCourses] = useState([]);
//     const [currentPage, setCurrentPage] = useState(0);
//     const [totalPages, setTotalPages] = useState(0);
//     const [totalCourses, setTotalCourses] = useState(0);
//     const [loading, setLoading] = useState(false);
//     const [isOpen, setIsOpen] = useState(true);
//     const { t } = useTranslation();
//     const navigate = useNavigate();
//     const userId = localStorage.getItem('userId');
//     const filterMenuRef = useRef();

    
     
//     const handleViewDetails = async (courseId) => {
//         if (!userId) {
//              navigate(`/coursedetails/${courseId}`)
//         }
//         try {
//             await SaveSearchedCourses(courseId, userId);
//             const isEnrolled = await checkEnrollmentStatus(courseId);
//             navigate(isEnrolled ? `/enrolledCourse/${courseId}` : `/coursedetails/${courseId}`);
//         } catch (error) {
//             console.log('Error saving search history. Please try again.');
//         }
//     };

//     const fetchCourses =useCallback( async (page) => {
//         if(!query) return;
        
//         setLoading(true);
//         try {
//             const response = await axios.get(`${COURSES_URL}/course/pagination`, {
//                 params: { searchTerm: query, page, size: 10 },
//             });
//             setCourses(response?.data?.data?.content);
//             setTotalPages(response?.data?.data?.totalPages);
//             setTotalCourses(response?.data?.data?.totalElements);
//         } catch (error) {
//             console.log('Error fetching courses. Please try again.');
//         } finally {
//             setLoading(false);
//         }
//     },[query]);

//     useEffect(() => {
//         if (query) {
//             fetchCourses(currentPage);
//         }
//     }, [query, currentPage, fetchCourses]);

//     const handlePageChange = (newPage) => {
//         if (newPage >= 0 && newPage < totalPages) {
//             setCurrentPage(newPage);
//         }
//     };

//     const applyFilters = async (filters) => {
//         try {
//             const res = await axios.get(`${COURSES_URL}/course/allFilter`, { params: filters });
//             setCourses(res?.data);
//             setTotalCourses(res?.data?.length);
//         } catch (error) {
//         }
//     };

//     const checkEnrollmentStatus = async (courseId) => {
//         try {
//             const response = await axios.get(`${ENROLLMENT_URL}/${userId}/${courseId}/getEnrollmentStatus`);
//             return response?.data;
//         } catch (error) {
//             console.log('Error checking enrollment status. Please try again.');
//         }
//     };

//     const handleClickOutside = (e) => {
//         if (filterMenuRef.current && !filterMenuRef.current.contains(e.target)) {
//             if (window.innerWidth <= 786) {
//                 setIsOpen(false);
//             }
//         }
//     };

//     useEffect(() => {
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => {
//             document.removeEventListener('mousedown', handleClickOutside);
//         };
//     }, []);

//     const handleFilterClose = () => {
//         setIsOpen(false);
//     };


//   useEffect(() => {
//     const handleResize = () => {
//       if (window.innerWidth < 786) {
//         setIsOpen(false);
//       } else {
//         setIsOpen(true);
//       }
//      };

//     handleResize();
//     window.addEventListener('resize', handleResize);

//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//     return (
//         <div className="search-results-container">
//              {loading ? (
//                 <ClipLoader color="#333333" loading={loading} size={30} id='clipLoader' />
//             ) : (
//                 <>
//                     <h1 className="search-results-title">{t('SearchResultsfor')} {query}</h1>
//                     <p style={{ fontSize: '10px', color: 'grey', marginTop: '-15px' }}>
//                         {t('Total')} {totalCourses} {t('Courses')}
//                     </p>
//                     {
//                         isOpen ? 
//                         <button className='apply-filter-button' onClick={handleFilterClose}>
//                             {t('Filters')}
//                         </button> : 
//                         <button className='apply-filter-button' onClick={() => setIsOpen(true)}>
//                             {t('Filters')}
//                         </button>
//                     }
//                     <div className='search-main-container'>
//                         <FilterComponent onFilter={applyFilters} isOpen={isOpen} ref={filterMenuRef} handleFilterClose={handleFilterClose} query={query} />
//                         {courses.length > 0 ? (
//                             <div className="search-results-list">
//                                 {courses?.map((course) => (
//                                     <div className="course-item" key={course.courseId} onClick={(e) => {
//                                         e.preventDefault();
//                                         handleViewDetails(course.courseId);
//                                     }}>
//                                         <div>
//                                             <img src={course.imageUrl} alt={course.title} className='search-results-img' />
//                                         </div>

//                                         <div className='search-course-details-container'>
//                                         <div >
//                                             <h3>{course.title}</h3>
//                                             <p className='description'>{course.description}</p>
//                                             <p>₹{course.price}</p>
//                                         </div>
//                                         <button
//                                             className="enrolledCourse-start-course"
//                                             onClick={(e) => {
//                                                 e.preventDefault();
//                                                 handleViewDetails(course.courseId);
//                                             }}
//                                         >
//                                             View Details
//                                         </button>
//                                         </div>
//                                     </div>
//                                 ))}
//                                 <div className="pagination">
//                                     <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0}>
//                                         Previous
//                                     </button>
//                                     {Array.from({ length: totalPages }, (_, index) => (
//                                         <button
//                                             key={index}
//                                             className={index === currentPage ? 'active' : ''}
//                                             onClick={() => handlePageChange(index)}
//                                         >
//                                             {index + 1}
//                                         </button>
//                                     ))}
//                                     <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1}>
//                                         Next
//                                     </button>
//                                 </div>
//                             </div>
//                         ) : (
//                             <p className="no-results">No courses found.</p>
//                         )}
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// };

// export default SearchResultsPage;

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './SearchResultsPage.css';
import ClipLoader from 'react-spinners/ClipLoader';
import { COURSES_URL, ENROLLMENT_URL, SaveSearchedCourses } from '../../Services/courseService';
import FilterComponent from './FilterComponent';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';

const SearchResultsPage = () => {
    const location = useLocation();
    const query = new URLSearchParams(location.search).get('query');
    const [courses, setCourses] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalCourses, setTotalCourses] = useState(0);
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(true);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userId = localStorage.getItem('userId');
    const filterMenuRef = useRef();

    // ✅ Updated: now takes courseId + courseTitle, navigates to /courses/:slug
    const handleViewDetails = async (courseId, courseTitle) => {
        if (!courseTitle) {
            console.error(`Missing courseTitle for courseId ${courseId}`);
            return;
        }

        // Create slug from title
        const slug = courseTitle
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');

        // Store slug → courseId mapping
        const slugCourseMap = JSON.parse(localStorage.getItem('slugCourseMap') || '{}');
        slugCourseMap[slug] = courseId;
        localStorage.setItem('slugCourseMap', JSON.stringify(slugCourseMap));

        if (!userId) {
            navigate(`/courses/${slug}`);
            return;
        }

        try {
            await SaveSearchedCourses(courseId, userId);
            const isEnrolled = await checkEnrollmentStatus(courseId);
            navigate(isEnrolled ? `/enrolledCourse/${courseId}` : `/courses/${slug}`);
        } catch (error) {
            console.log('Error saving search history. Please try again.', error);
        }
    };

    const fetchCourses = useCallback(async (page) => {
        if (!query) return;

        setLoading(true);
        try {
            const response = await axios.get(`${COURSES_URL}/course/pagination`, {
                params: { searchTerm: query, page, size: 10 },
            });
            setCourses(response?.data?.data?.content);
            setTotalPages(response?.data?.data?.totalPages);
            setTotalCourses(response?.data?.data?.totalElements);
        } catch (error) {
            console.log('Error fetching courses. Please try again.');
        } finally {
            setLoading(false);
        }
    }, [query]);

    useEffect(() => {
        if (query) {
            fetchCourses(currentPage);
        }
    }, [query, currentPage, fetchCourses]);

    const handlePageChange = (newPage) => {
        if (newPage >= 0 && newPage < totalPages) {
            setCurrentPage(newPage);
        }
    };

    const applyFilters = async (filters) => {
        try {
            const res = await axios.get(`${COURSES_URL}/course/allFilter`, { params: filters });
            setCourses(res?.data);
            setTotalCourses(res?.data?.length);
        } catch (error) { }
    };

    const checkEnrollmentStatus = async (courseId) => {
        try {
            const response = await axios.get(`${ENROLLMENT_URL}/${userId}/${courseId}/getEnrollmentStatus`);
            return response?.data;
        } catch (error) {
            console.log('Error checking enrollment status. Please try again.');
        }
    };

    const handleClickOutside = (e) => {
        if (filterMenuRef.current && !filterMenuRef.current.contains(e.target)) {
            if (window.innerWidth <= 786) {
                setIsOpen(false);
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleFilterClose = () => {
        setIsOpen(false);
    };

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 786) {
                setIsOpen(false);
            } else {
                setIsOpen(true);
            }
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="search-results-container">
            {loading ? (
                <ClipLoader color="#333333" loading={loading} size={30} id='clipLoader' />
            ) : (
                <>
                    <h1 className="search-results-title">{t('SearchResultsfor')} {query}</h1>
                    <p style={{ fontSize: '10px', color: 'grey', marginTop: '-15px' }}>
                        {t('Total')} {totalCourses} {t('Courses')}
                    </p>
                    {
                        isOpen ?
                            <button className='apply-filter-button' onClick={handleFilterClose}>
                                {t('Filters')}
                            </button> :
                            <button className='apply-filter-button' onClick={() => setIsOpen(true)}>
                                {t('Filters')}
                            </button>
                    }
                    <div className='search-main-container'>
                        <FilterComponent onFilter={applyFilters} isOpen={isOpen} ref={filterMenuRef} handleFilterClose={handleFilterClose} query={query} />
                        {courses.length > 0 ? (
                            <div className="search-results-list">
                                {courses?.map((course) => (
                                    <div
                                        className="course-item"
                                        key={course.courseId}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handleViewDetails(course.courseId, course.title);
                                        }}
                                    >
                                        <div>
                                            <img src={course.imageUrl} alt={course.title} className='search-results-img' />
                                        </div>

                                        <div className='search-course-details-container'>
                                            <div>
                                                <h3>{course.title}</h3>
                                                <p className='description'>{course.description}</p>
                                                <p>₹{course.price}</p>
                                            </div>
                                            <button
                                                className="enrolledCourse-start-course"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleViewDetails(course.courseId, course.title);
                                                }}
                                            >
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                <div className="pagination">
                                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0}>
                                        Previous
                                    </button>
                                    {Array.from({ length: totalPages }, (_, index) => (
                                        <button
                                            key={index}
                                            className={index === currentPage ? 'active' : ''}
                                            onClick={() => handlePageChange(index)}
                                        >
                                            {index + 1}
                                        </button>
                                    ))}
                                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1}>
                                        Next
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <p className="no-results">No courses found.</p>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default SearchResultsPage;
